import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  setReportArea: ["area", "areaLabel"]
});

/**
 * Handlers
 */
const INITIAL_STATE = {
  area: null,
  areaLabel: null
};

const setReportArea = (state = INITIAL_STATE, action) => {
  const { area, areaLabel } = action;
  return {
    ...state,
    area,
    areaLabel
  };
};

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.SET_REPORT_AREA]: setReportArea
});
